"use client"

import {
  Box,
  Grid,
  GridItem,
  HStack,
  Skeleton,
  Stack,
  VStack,
} from "@chakra-ui/react"

function SkillCardSkeleton({
  area,
  isLarge = false,
}: {
  area: string
  isLarge?: boolean
}) {
  return (
    <GridItem
      bgColor="bg.paper"
      borderRadius={{ base: "14px", md: "18px" }}
      display="flex"
      flexDirection="column"
      gridArea={area}
      justifyContent="space-between"
      minH={{
        base: isLarge ? "320px" : "260px",
        md: isLarge ? "360px" : "300px",
        xl: "100%",
      }}
      overflow="hidden"
      p={isLarge ? 0 : { base: 4, md: 5 }}
    >
      <VStack
        alignItems="flex-start"
        gap={3}
        p={isLarge ? { base: 4, md: 5 } : 0}
      >
        <Skeleton
          h={{ base: 6, md: 7 }}
          rounded="lg"
          variant="shine"
          w={isLarge ? "148px" : "62%"}
        />
        <Stack gap={2} w="full">
          <Skeleton h={3} rounded="full" variant="shine" w="88%" />
          <Skeleton h={3} rounded="full" variant="shine" w="68%" />
        </Stack>
      </VStack>
      <HStack
        justifyContent="center"
        pb={isLarge ? 0 : 2}
        px={isLarge ? 0 : 2}
        w="full"
      >
        <Skeleton
          h={
            isLarge
              ? { base: "180px", md: "230px", xl: "320px" }
              : { base: "150px", md: "180px" }
          }
          rounded={isLarge ? "0" : "xl"}
          variant="shine"
          w="full"
        />
      </HStack>
    </GridItem>
  )
}

export default function SkillsBentoSkeleton() {
  return (
    <Box aria-busy="true" as="section" mb={6} px={{ base: 0 }} width="100%">
      <Grid
        alignItems="stretch"
        display="grid"
        gap={6}
        gridAutoRows={{
          base: "auto",
          md: "minmax(64px, auto)",
          xl: "minmax(72px, auto)",
        }}
        gridTemplateAreas={{
          base: "'ui' 'ds' 'sk' 'jm' 'ai'",
          md: `'ui ui ui ui ui ui ui ui'
              'ds ds ds ds ds ds ds ds'
              'sk sk sk sk jm jm jm jm'
              'ai ai ai ai ai ai ai ai'`,
          xl: `'ui ui ui ui ds ds'
              'ui ui ui ui ds ds'
              'ui ui ui ui ds ds'
              'ui ui ui ui ds ds'
              'sk sk jm jm ds ds'
              'sk sk jm jm ai ai'
              'sk sk jm jm ai ai'`,
        }}
        gridTemplateColumns={{
          base: "repeat(1, 1fr)",
          md: "repeat(8, 1fr)",
          xl: "repeat(6, 1fr)",
        }}
        role="presentation"
      >
        <SkillCardSkeleton area="ui" isLarge />
        <SkillCardSkeleton area="ds" />
        <SkillCardSkeleton area="sk" />
        <SkillCardSkeleton area="jm" />
        <SkillCardSkeleton area="ai" />
      </Grid>
    </Box>
  )
}
